import App from "../../componets/Form"

export default function Section2() {
  return (
    <div className="w-full Section2 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 relative w-full md:w-[750px] lg:w-[970px] xl:w-[100%] md:px-[15px] mx-auto section2-container">
        <App />
      </div>
    </div>
  );
}
